import { useEffect, useState } from "react"
import "../../../styles/themes.css"
import "../../../styles/bill.css"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { useParams } from "react-router-dom"
import { IReplenishmentDto } from "../../../types/replenishment/IReplenishmentDto"
import { IBrockmanBankDto } from "../../../types/brockman/IBrockmanBankDto"
import { IBrockmanDetailDto } from "../../../types/brockman/IBrockmanDetailDto"
import { getFormattedDate, round4Digits, spacedNum } from "../../common/CommonHelper"
import { IClientRequestDto } from "../../../types/request/IClientRequestDto"
import { getStorageUrl } from "@/lib/helper"

export const Bill = () => {
  const params = useParams()
  const [replenishment, setReplenishment] = useState<IReplenishmentDto>()
  const [clientRequest, setClientRequest] = useState<IClientRequestDto>()
  const [brockman, setBrockman] = useState<IBrockmanBankDto>()
  const [brockmanDetail, setBrockmanDetail] = useState<IBrockmanDetailDto>()

  useEffect(() => {
    if (!params.id) return
    TrinityAPI.getReplenishment(Number(params.id), response => {
      if (response.status === 200) {
        setReplenishment(response.data)
      } else {
        alert("Счет не найден")
      }
    })
  }, [])

  useEffect(() => {
    if (!replenishment?.additionalAgreementBankId) return
    TrinityAPI.getClientRequest(Number(replenishment.clientRequestId), response => {
      if (response.status === 200) {
        setClientRequest(response.data)
      }
    })
    TrinityAPI.getBrockmanBank(replenishment?.additionalAgreementBankId, response => {
      if (response.status === 200) {
        setBrockman(response.data)
        setBrockmanDetail(response.data.brockmanDetail)
      }
    })
  }, [replenishment])

  useEffect(() => {
    if (brockman && brockmanDetail && replenishment && clientRequest) {
      setTimeout(() => window.print(), 1000)
    }
  }, [brockman, brockmanDetail, replenishment, clientRequest])

  const getExchangeRate = () => {
    if (replenishment?.rubAmountAfter && replenishment.invoiceAmount) {
      return spacedNum(round4Digits(Number(replenishment.rubAmountAfter) / Number(replenishment.invoiceAmount)))
    } else {
      return ""
    }
  }

  if (brockman && brockmanDetail && replenishment && clientRequest) {
    return (
      <div className="container-schet" style={{ backgroundColor: "white" }}>
        <div className="paper">
          <div className="header-paper">
            <h1 className="header-paper-name">{brockmanDetail?.name}</h1>
            <p>{brockmanDetail?.beneficiaryAddress}</p>
          </div>

          <div className="paper-first">
            <p>
              Invoice date: <span>{getFormattedDate(replenishment?.billDate || new Date().toString())}</span>
            </p>
          </div>

          <div className="invoice">
            <p className="first-invoice">invoice</p>
            <p className="invoice-number">{replenishment?.id}BM</p>
          </div>

          <ul className="flex-row">
            <li className="flex-block">
              <p className="flex-block-heading">Received from:</p>
              <p className="flex-block-name">
                {brockmanDetail?.name}
                <span>Address: {brockmanDetail?.beneficiaryAddress}</span>
              </p>
              <p className="flex-block-banking">
                Banking details:
                <span>{brockmanDetail?.name}</span>
              </p>
              <div className="info">
                <p>
                  Beneficiary Address:&nbsp;
                  <span>{brockmanDetail?.beneficiaryAddress}</span>
                </p>
                <p>
                  Bank name:&nbsp;
                  <span>{brockman?.name}</span>
                </p>
                <p>
                  Bank address:&nbsp;
                  <span>{brockman?.address}</span>
                </p>
                <p>
                  BIC:&nbsp;
                  <span>{brockman?.bic}</span>
                </p>
                <p>
                  Account in RUR:&nbsp;
                  <span>{brockman?.account}</span>
                </p>
                <p>
                  INN:&nbsp;
                  <span>{brockman?.inn}</span>
                </p>
              </div>
            </li>
            <li className="flex-block">
              <p className="flex-block-heading">Bill to:</p>
              <p className="flex-block-name">
                {clientRequest?.clientCompanyName}
                <span>Address: {clientRequest?.innRegistry?.address}</span>
              </p>
            </li>
          </ul>

          <div className="table">
            <div className="contract-info">
              Contract No {replenishment?.contractNumber} dated {getFormattedDate(replenishment?.contractDate || "")}
            </div>

            <div className="table">
              <ul className="column">
                <li>#</li>
                <li>Service description</li>
                <li>Amount, {replenishment.invoiceCurrency}</li>
                <li>Exchange rate, {replenishment.invoiceCurrency}/RUR</li>
                <li>Total, RUR</li>
              </ul>
              <ul className="column">
                <li>1.</li>
                <li>
                  Дополнительное соглашение №{replenishment.additionalAgreementNumber} от{" "}
                  {getFormattedDate(replenishment?.additionalAgreementDate || "") + " "}к контракту №
                  {replenishment?.contractNumber} от {getFormattedDate(replenishment?.contractDate || "")}, инвойс{" "}
                  {replenishment?.invoiceNumber} от {getFormattedDate(replenishment?.invoiceDate || "")}
                </li>
                <li>
                  {replenishment?.invoiceAmount
                    ? spacedNum(Number(replenishment?.invoiceAmount) / 100).replace(".", ",")
                    : ""}
                </li>
                <li>1 / {getExchangeRate()}</li>
                <li>
                  {replenishment?.rubAmountAfter
                    ? spacedNum(Number(replenishment.rubAmountAfter) / 100).replace(".", ",")
                    : ""}
                </li>
              </ul>
            </div>

            <div className="total">
              <p>Total:</p>
              <p>
                {replenishment?.rubAmountBefore
                  ? spacedNum(Number(replenishment.rubAmountBefore) / 100).replace(".", ",")
                  : ""}
              </p>
              <p>RUR</p>
            </div>

            <div className="legal">
              <div className="legal-text">/ {brockmanDetail?.personPosition}</div>
              <div className="legal-img">
                <img src={`${getStorageUrl()}/${brockmanDetail?.stampPath}`} alt="stamp" className="legal-img-stamp" />
                <img src={`${getStorageUrl()}/${brockmanDetail?.signPath}`} alt="sign" className="legal-img-sign" />
              </div>
              <div className="legal-text">{brockmanDetail?.personName}</div>
            </div>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className="container-schet">
        <div className="paper">Формируем...</div>
      </div>
    )
  }
}
